import { render } from "./CloseButton.vue?vue&type=template&id=f6b6e0d0&scoped=true"
const script = {}

import "./CloseButton.vue?vue&type=style&index=0&id=f6b6e0d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b6e0d0"]])

export default __exports__